import { API } from "../lib/api";

export const fetchCustomersAndUsers = async () => {
    const [customerData, usersData] = await Promise.all([
      API.Customers.FetchAll(),
      API.Users.FetchAll(),
    ]);
    const formattedUsers = usersData.map(user => ({
      label: `${user.firstName} ${user.lastName}`,
      id: user._id,
    }));
    return { customers: customerData, users: formattedUsers };
};

export const useCustomerActions = ({
    setCustomers,
    setFeedback,
    addCustomer,
    setSelectedRows,
    handleCloseCreateModal,
    handleCloseUpdateModal,
  }) => {
    const handleCreateSubmit = async (data) => {
      const response = await API.Customers.Create(localStorage.id, data);
      if (response.status === 200) {
        addCustomer(response.data.data);
        setFeedback({
          open: true,
          message: response.data.message,
          type: "success",
        });
      } else {
        setFeedback({
          open: true,
          message: response.data.message,
          type: "error",
        });
      }
      handleCloseCreateModal();
    };
  
    const handleUpdateSubmit = async (data, selectedRows) => {
      const updatedFields = Object.entries(data).reduce((acc, [key, val]) => {
        if (val === undefined || val === null || val === "") return acc;
        acc[key] = typeof val === "object" && (val.id || val._id) ? val.id || val._id : val;
        return acc;
      }, {});
  
      const payload = selectedRows.map((_id) => ({ _id, data: updatedFields }));
      const response = await API.Customers.Update(payload);
  
      if (response.status === 200) {
        const updatedMap = new Map(response.data.data.map((c) => [c._id, c]));
        setCustomers((prev) => prev.map((c) => updatedMap.get(c._id) || c));
        setFeedback({
          open: true,
          message: response.data.message,
          type: "success",
        });
      } else {
        setFeedback({
          open: true,
          message: "Error updating customer(s)...",
          type: "error",
        });
      }
  
      handleCloseUpdateModal();
    };
  
    const handleDeleteSubmit = async (selectedRows) => {
      const response = await API.Customers.Delete(selectedRows);
      if (response.status === 200) {
        setCustomers((prev) =>
          prev.filter((c) => !selectedRows.includes(c._id))
        );
        setFeedback({
          open: true,
          message: response.data.message,
          type: "success",
        });
      } else {
        setFeedback({
          open: true,
          message: response.data.message,
          type: "error",
        });
      }
      setSelectedRows([]);
      handleCloseUpdateModal();
    };
  
    const handleMoveToDash = async (selectedRows) => {
      const response = await API.Dashboard.SendCustomersToDash(
        localStorage.id,
        selectedRows
      );
      if (response.status === 200) {
        setFeedback({
          open: true,
          message: response.data.message,
          type: "success",
        });
      } else {
        setFeedback({
          open: true,
          message: response.data.message,
          type: "error",
        });
      }
      setSelectedRows([]);
      handleCloseUpdateModal();
    };
  
    return {
      handleCreateSubmit,
      handleUpdateSubmit,
      handleDeleteSubmit,
      handleMoveToDash,
    };
};
